import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | AutoNeova"
        description="The page you requested could not be found on the AutoNeova website."
        path="/404"
      />
      <section
        data-testid="not-found-page"
        className="bg-white px-5 py-28 lg:px-8 lg:py-36"
      >
        <div className="mx-auto max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#1F6FEB]">
            Error 404
          </p>
          <h1 className="mt-4 text-4xl font-extrabold text-[#0B1F33] sm:text-5xl">
            Page not found
          </h1>
          <p className="mt-6 text-base leading-relaxed text-[#263238]">
            The page you requested is not available. Please use the navigation above or return to the
            home page.
          </p>
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="mt-9 inline-flex items-center justify-center rounded-md bg-[#1F6FEB] px-6 py-3 text-sm font-semibold text-white transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#1655B8]"
          >
            Back to home
          </Link>
        </div>
      </section>
    </>
  );
}
